// Copyright ©️ 2026 eVolve MEP, LLC

import {
  type BendPreviewSpecifications,
  BendPreviewGeometry,
} from 'modules/Shop/EvolveFabrication/BendCreator/BendPreview/BendPreviewGeometry';
import type { PlacementOffset } from 'modules/Shop/EvolveFabrication/BendCreator/BendPreview/Labels/buildLabelOpts';

export class Kick90BackToBackGeometry extends BendPreviewGeometry {
  direction: 'right' | 'left';
  constructor(direction: 'right' | 'left') {
    super();
    this.direction = direction;
  }

  createBendDefs(dimensions: BendPreviewSpecifications) {
    const { tailLength, offsetHeight, noseLength } = dimensions;
    const directionMultiplier = this.direction === 'left' ? 1 : -1;

    // We want the labels to be on the outside of the bend. See the comment on Kick90Geometry for more details.
    const labelPlacementOffset: PlacementOffset = {
      relativeTo: 'bendPlane',
      offset: this.direction === 'left' ? 'right' : 'left',
    };

    return [
      {
        runLength: tailLength,
        endMeasuredTo: 'tubeEdge',
        thenBendBy: Math.PI / 2,
        startLabels: [
          {
            label: 'Tail Length',
            length: tailLength,
            offsets: [{ relativeTo: 'world', offset: 'down' }, labelPlacementOffset],
          },
        ],
      },
      {
        runLength: offsetHeight,
        thenRotateBy: (Math.PI / 2) * directionMultiplier,
        thenBendBy: -Math.PI / 2,
        startLabels: [
          {
            label: 'Offset Height',
            length: offsetHeight,
            offsets: [
              { relativeTo: 'bendPlane', offset: 'backward' },
              { relativeTo: 'bendPlane', offset: 'bottom' },
              labelPlacementOffset,
            ],
          },
        ],
      },
      {
        runLength: noseLength,
        startMeasuredFrom: 'tubeEdge',
        startLabels: [
          {
            label: 'Nose Length',
            length: noseLength,
            offsets: [
              { relativeTo: 'bendPlane', offset: 'backward' },
              { relativeTo: 'world', offset: 'down' },
              labelPlacementOffset,
            ],
          },
        ],
      },
    ] as const;
  }
}
